export default {
  CARE_PROGRAM_TYPE: {
    BILYPSA: 'bilypsa',
    AKUMENTIS: 'akumentis',
    ANAYA: 'anaya',
    PROSTATE: 'prostate',
  },
}
